import styled from 'styled-components'
import Button from 'components/Button'

export const MapContainer = styled.div`
  height: 300px;
  margin: 0 0 0 30px;
  padding: 10px;
  border: 1px solid #c3c3c3;
  position: relative;
`

export const MapTitle = styled.div`
  font-family: Plus Jakarta Sans;
  font-weight: 400;
  font-style: Regular;
  font-size: 10px;
  line-height: 18px;

  span {
    font-family: Plus Jakarta Sans;
    font-weight: 700;
  }
`

export const ChartContainer = styled.div`
  height: 320px;
  margin: 0 0 0 30px;
  padding: 10px;
  border: 1px solid #c3c3c3;
  position: relative;
  overflow: hidden;
`
export const StyledWrapper = styled.div`
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  height: '100%',
`

export const ChartTitle = styled.div`
  font-family: Plus Jakarta Sans;
  font-weight: 400;
  font-size: 10px;
  line-height: 18px;
  margin-bottom: 5px;

  span {
    font-family: Plus Jakarta Sans;
    font-weight: 700;
    font-style: Bold;
    font-size: 10px;
    line-height: 18px;
  }
`

export const StyledViewAllBtn = styled(Button.Default)`
  .secondary_icon_container {
    flex-direction: row-reverse;
    gap: 10px;
  }
  .secondary_text_container {
    font-size: 13px;
    font-weight: 500;
    color: #000000;
  }
`

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

export const ModalContent = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  width: 80%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
`

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
`

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: ${props => props.fontSize || '18px'};
  font-weight: 600;
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
`

export const DetailedLegend = styled.div`
  margin-top: 20px;
  padding: 10px;
`
